import { motion } from "framer-motion";
import { LockKeyhole, MessageCircle, Nfc, Sparkles } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { SectionHead } from "@/components/SectionHead";

const ICONS = [Nfc, LockKeyhole, MessageCircle];

export const HowItWorks = () => {
  const { t } = useLang();
  const h = t.how;

  return (
    <section id="how" className="bg-creamdeep/60 py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHead kicker={h.kicker} title={h.title} center />
        <div className="mt-12 grid gap-5 md:grid-cols-3">
          {h.steps.map((step, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.15 }}
                transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
                className="relative overflow-hidden rounded-[2rem] border border-cardline bg-white p-8"
                data-testid={`how-step-${i}`}
              >
                <span className="pointer-events-none absolute -top-2 end-6 font-display text-7xl font-extrabold text-pine/[0.08]">{step.n}</span>
                <span className="grid h-12 w-12 place-items-center rounded-2xl bg-pine-light text-pine">
                  <Icon className="h-6 w-6" />
                </span>
                <h3 className="mt-6 font-display text-2xl font-bold text-ink">{step.t}</h3>
                <p className="mt-3 leading-relaxed text-inksoft">{step.b}</p>
              </motion.div>
            );
          })}
        </div>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mx-auto mt-10 flex w-fit items-center gap-3 rounded-full bg-pine px-6 py-3 text-sm font-bold text-cream"
          data-testid="how-teacher-note"
        >
          <Sparkles className="h-4 w-4 text-sun" />
          {h.note}
        </motion.div>
      </div>
    </section>
  );
};
